// webapp/src/LoginPage.js
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { supabase } from './supabase';
import config_names from './config_names';
import { 
  FiMail, 
  FiAlertCircle, 
  FiArrowLeft 
} from 'react-icons/fi';
import { FaGoogle } from 'react-icons/fa';
import './auth-pages.css';

const getErrorMessage = (error) => {
  if (!error) return 'An unexpected error occurred. Please try again.';

  switch (error.message) {
    case 'Invalid login credentials':
      return 'Incorrect email or password. Please try again.';
    case 'Email not confirmed':
      return 'Please confirm your email address before logging in.';
    default:
      return error.message || 'An unexpected error occurred. Please try again.';
  }
};

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [showEmailLogin, setShowEmailLogin] = useState(false);
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: window.location.origin + '/dashboard'
        }
      });
  
      if (error) throw error;
      // The redirect will be handled by Google OAuth
    } catch (error) {
      setError(getErrorMessage(error));
    }
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    setError(null);
    
    try {
      const { error } = await supabase.auth.signInWithPassword({
        email,
        password
      });
  
      if (error) throw error;
      
      // Use absolute path instead of relative path
      navigate('/dashboard');
    } catch (error) {
      setError(getErrorMessage(error));
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Welcome Back</h1>
          <p>Sign in to continue to {config_names.projectName}</p>
        </div>

        {error && (
          <div className="auth-error">
            <FiAlertCircle />
            <span>{error}</span>
          </div>
        )}

        {!showEmailLogin ? (
          <>
            <button 
              className="auth-btn google-btn" 
              onClick={handleGoogleLogin}
            >
              <FaGoogle /> Sign in with Google
            </button>
            
            <div className="auth-divider">or</div>
            
            <button 
              className="auth-btn primary-btn" 
              onClick={() => setShowEmailLogin(true)}
            >
              <FiMail /> Sign in with Email
            </button>
          </>
        ) : (
          <form className="auth-form" onSubmit={handleLogin}>
            <div className="form-group">
              <div className="input-icon-wrapper">
                <input 
                  type="email" 
                  className="form-control" 
                  placeholder="Email" 
                  value={email} 
                  onChange={(e) => setEmail(e.target.value)} 
                  required 
                />
              </div>
            </div>
            
            <div className="form-group">
              <div className="input-icon-wrapper">
                <input 
                  type="password" 
                  className="form-control" 
                  placeholder="Password" 
                  value={password} 
                  onChange={(e) => setPassword(e.target.value)} 
                  required 
                />
              </div>
            </div>
            
            <button type="submit" className="auth-btn primary-btn">
              <FiMail /> Sign in
            </button>
            
            <button 
              type="button" 
              className="auth-btn secondary-btn" 
              onClick={() => setShowEmailLogin(false)}
            >
              <FiArrowLeft /> Back
            </button>
          </form>
        )}

        <div className="auth-footer">
          <span>New to {config_names.projectName}? </span>
          <Link to="/signup">Sign up now</Link>
        </div>

        <div className="auth-legal">
          By continuing, you acknowledge that you accept {config_names.projectName_genitive}{' '}
          <a href={`${config_names.domain}/terms`}>Terms of Use</a> and{' '}
          <a href={`${config_names.domain}/privacy`}>Privacy Policy</a>.
        </div>
      </div>
    </div>
  );
}

export default LoginPage;